import {
  NumberOrNullOrUndefined,
  StringOrNullOrUndefined,
  DateOrNullOrUndefined,
  BooleanOrNullOrUndefined,
} from 'src/app/shared/utils';

export class MedicalDevelopmentHistory {
  history_id?: number;
  assessment_id?: number;
  diagnoses?: string;
  pregnancy_complications?: string;
  has_seizures?: boolean;
  seizure_description?: string;
  allergies?: string;
  additional_medical_complications?: string;
  constructor(data: Partial<MedicalDevelopmentHistory> = {}) {
    this.history_id = NumberOrNullOrUndefined(data.history_id);
    this.assessment_id = NumberOrNullOrUndefined(data.assessment_id);
    this.diagnoses = StringOrNullOrUndefined(data.diagnoses);
    this.pregnancy_complications = StringOrNullOrUndefined(data.pregnancy_complications);
    this.has_seizures = BooleanOrNullOrUndefined(data.has_seizures) ?? false;
    this.seizure_description = StringOrNullOrUndefined(data.seizure_description);
    this.allergies = StringOrNullOrUndefined(data.allergies);
    this.additional_medical_complications = StringOrNullOrUndefined(data.additional_medical_complications);
  }
}

export class FamilyLegalHistory {
  family_history_id?: number;
  assessment_id?: number;
  family_history?: string;
  legal_marital_issues?: string;
  constructor(data: Partial<FamilyLegalHistory> = {}) {
    this.family_history_id = NumberOrNullOrUndefined(data.family_history_id);
    this.assessment_id = NumberOrNullOrUndefined(data.assessment_id);
    this.family_history = StringOrNullOrUndefined(data.family_history);
    this.legal_marital_issues = StringOrNullOrUndefined(data.legal_marital_issues);
  }
}

export class EducationalTherapeuticProgram {
  program_id?: number;
  assessment_id?: number;
  program_name?: string;
  program_type?: string;
  weekly_frequency?: number;
  hours_per_session?: string;
  location?: string;
  constructor(data: Partial<EducationalTherapeuticProgram> = {}) {
    this.program_id = NumberOrNullOrUndefined(data.program_id);
    this.assessment_id = NumberOrNullOrUndefined(data.assessment_id);
    this.program_name = StringOrNullOrUndefined(data.program_name);
    this.program_type = StringOrNullOrUndefined(data.program_type);
    this.weekly_frequency = NumberOrNullOrUndefined(data.weekly_frequency);
    this.hours_per_session = StringOrNullOrUndefined(data.hours_per_session);
    this.location = StringOrNullOrUndefined(data.location);
  }
}

export class SchoolDaycareInfo {
  school_id?: number;
  assessment_id?: number;
  school_daycare_name?: string;
  grade_special_class?: string;
  constructor(data: Partial<SchoolDaycareInfo> = {}) {
    this.school_id = NumberOrNullOrUndefined(data.school_id);
    this.assessment_id = NumberOrNullOrUndefined(data.assessment_id);
    this.school_daycare_name = StringOrNullOrUndefined(data.school_daycare_name);
    this.grade_special_class = StringOrNullOrUndefined(data.grade_special_class);
  }
}

export class AbaServicesInfo {
  aba_service_id?: number;
  assessment_id?: number;
  received_aba?: boolean;
  start_date?: string;
  end_date?: string;
  treatment_response?: string;
  constructor(data: Partial<AbaServicesInfo> = {}) {
    this.aba_service_id = NumberOrNullOrUndefined(data.aba_service_id);
    this.assessment_id = NumberOrNullOrUndefined(data.assessment_id);
    this.received_aba = BooleanOrNullOrUndefined(data.received_aba) ?? false;
  const rec = data as Record<string, unknown>;
  this.start_date = StringOrNullOrUndefined(rec['start_date'] as string | null | undefined);
  this.end_date = StringOrNullOrUndefined(rec['end_date'] as string | null | undefined);
    this.treatment_response = StringOrNullOrUndefined(data.treatment_response);
  }
}

export class HealthBehaviors {
  behavior_id?: number;
  assessment_id?: number;
  elopement?: boolean;
  elopement_description?: string;
  climbs_unsafe_furniture?: boolean;
  climbs_unsafe_furniture_description?: string;
  mouths_inedibles?: boolean;
  mouths_inedibles_description?: string;
  self_injury?: boolean;
  throws_objects?: boolean;
  throws_objects_description?: string;
  physical_aggression?: boolean;
  physical_aggression_description?: string;

  constructor(data: Partial<HealthBehaviors> = {}) {
    this.behavior_id = NumberOrNullOrUndefined(data.behavior_id);
    this.assessment_id = NumberOrNullOrUndefined(data.assessment_id);
    this.elopement = BooleanOrNullOrUndefined(data.elopement) ?? false;
    this.elopement_description = StringOrNullOrUndefined((data as Record<string, unknown>)['elopement_description'] as string | null | undefined);
  this.climbs_unsafe_furniture = BooleanOrNullOrUndefined(data.climbs_unsafe_furniture) ?? false;
  this.climbs_unsafe_furniture_description = StringOrNullOrUndefined((data as Record<string, unknown>)['climbs_unsafe_furniture_description'] as string | null | undefined);
  this.mouths_inedibles = BooleanOrNullOrUndefined(data.mouths_inedibles) ?? false;
  this.mouths_inedibles_description = StringOrNullOrUndefined((data as Record<string, unknown>)['mouths_inedibles_description'] as string | null | undefined);
    this.self_injury = BooleanOrNullOrUndefined(data.self_injury) ?? false;
    this.throws_objects = BooleanOrNullOrUndefined(data.throws_objects) ?? false;
    this.throws_objects_description = StringOrNullOrUndefined((data as Record<string, unknown>)['throws_objects_description'] as string | null | undefined);
    this.physical_aggression = BooleanOrNullOrUndefined((data as Record<string, unknown>)['physical_aggression'] as boolean | null | undefined) ?? false;
    this.physical_aggression_description = StringOrNullOrUndefined((data as Record<string, unknown>)['physical_aggression_description'] as string | null | undefined);
  }
}

export class PastCurrentTreatments {
  treatment_id?: number;
  assessment_id?: number;
  past_treatment?: string;
  current_treatment?: string;

  constructor(data: Partial<PastCurrentTreatments> = {}) {
    this.treatment_id = NumberOrNullOrUndefined(data.treatment_id);
    this.assessment_id = NumberOrNullOrUndefined(data.assessment_id);
    this.past_treatment = StringOrNullOrUndefined(data.past_treatment);
    this.current_treatment = StringOrNullOrUndefined(data.current_treatment);
  }
}

export class EducationalMedicalStatus {
  status_id?: number;
  assessment_id?: number;
  educational_status?: string;
  medical_status?: string;
  strengths?: string;
  weaknesses?: string;

  constructor(data: Partial<EducationalMedicalStatus> = {}) {
    this.status_id = NumberOrNullOrUndefined(data.status_id);
    this.assessment_id = NumberOrNullOrUndefined(data.assessment_id);
    this.educational_status = StringOrNullOrUndefined(data.educational_status);
    this.medical_status = StringOrNullOrUndefined(data.medical_status);
    this.strengths = StringOrNullOrUndefined(data.strengths);
    this.weaknesses = StringOrNullOrUndefined(data.weaknesses);
  }
}

export class OtherTherapyService {
  service_id?: number;
  assessment_id?: number;
  service_name?: string;
  description?: string;

  constructor(data: Partial<OtherTherapyService> = {}) {
    this.service_id = NumberOrNullOrUndefined(data.service_id);
    this.assessment_id = NumberOrNullOrUndefined(data.assessment_id);
    this.service_name = StringOrNullOrUndefined(data.service_name);
    this.description = StringOrNullOrUndefined(data.description);
  }
}

export class ConductedAssessmentRecord {
  assessment_record_id?: number;
  assessment_id?: number;
  assessment_name?: string;
  assessment_date?: string;
  results?: string;

  constructor(data: Partial<ConductedAssessmentRecord> = {}) {
    this.assessment_record_id = NumberOrNullOrUndefined(data.assessment_record_id);
    this.assessment_id = NumberOrNullOrUndefined(data.assessment_id);
    this.assessment_name = StringOrNullOrUndefined(data.assessment_name);
    this.assessment_date = StringOrNullOrUndefined(data.assessment_date);
    this.results = StringOrNullOrUndefined(data.results);
  }
}

export class SettingEventAntecedent {
  event_id?: number;
  assessment_id?: number;
  event_description?: string;

  constructor(data: Partial<SettingEventAntecedent> = {}) {
    this.event_id = NumberOrNullOrUndefined(data.event_id);
    this.assessment_id = NumberOrNullOrUndefined(data.assessment_id);
    this.event_description = StringOrNullOrUndefined(data.event_description);
  }
}

export class PreferenceAssessment {
  preference_id?: number;
  assessment_id?: number;
  preferences?: string;

  constructor(data: Partial<PreferenceAssessment> = {}) {
    this.preference_id = NumberOrNullOrUndefined(data.preference_id);
    this.assessment_id = NumberOrNullOrUndefined(data.assessment_id);
    this.preferences = StringOrNullOrUndefined(data.preferences);
  }
}

export class InitialAssessmentPatientSummary {
  id?: number;
  first_name?: string;
  last_name?: string;
  birth_date?: Date | string;
  age?: number;

  constructor(data: Partial<InitialAssessmentPatientSummary> = {}) {
    this.id = NumberOrNullOrUndefined(data.id);
    this.first_name = StringOrNullOrUndefined(data.first_name);
    this.last_name = StringOrNullOrUndefined(data.last_name);
    this.birth_date = data.birth_date ? DateOrNullOrUndefined(data.birth_date) : undefined;
    this.age = NumberOrNullOrUndefined(data.age);
  }
}

export class InitialAssessment {
  assessment_id?: number;
  bip_id?: number;
  patient_id: number = 0;
  person_responding?: string;
  observation_date?: string;
  current_insurance_provider?: string;
  additional_insurance?: string;
  home_community_description?: string;
  has_own_room?: boolean;
  shares_room_with?: string;
  primary_language_spoken?: string;
  history_trauma?: string;
  comorbidities?: string;
  household_members: string[];
  concurrent_97153_97156_medical_necessity?: string;
  impairs_other_services_without_rbt?: boolean;
  impairs_other_services_description?: string;
  documents_and_result?: string;
  created_at?: Date;
  updated_at?: Date;

  medical_development_history?: MedicalDevelopmentHistory;
  family_legal_history?: FamilyLegalHistory;
  educational_therapeutic_programs: EducationalTherapeuticProgram[];
  school_daycare_info?: SchoolDaycareInfo;
  aba_services?: AbaServicesInfo;
  health_behaviors?: HealthBehaviors;
  past_current_treatments?: PastCurrentTreatments;
  educational_medical_status?: EducationalMedicalStatus;
  other_therapy_services: OtherTherapyService[];
  conducted_assessments: ConductedAssessmentRecord[];
  setting_events_antecedents: SettingEventAntecedent[];
  preference_assessment?: PreferenceAssessment;
  patient?: InitialAssessmentPatientSummary;

  constructor(data: Partial<InitialAssessment> = {}) {
    this.assessment_id = NumberOrNullOrUndefined(data.assessment_id);
    this.bip_id = NumberOrNullOrUndefined((data as Record<string, unknown>)['bip_id'] as number | null | undefined);
    this.patient_id = NumberOrNullOrUndefined(data.patient_id) ?? 0;
    this.person_responding = StringOrNullOrUndefined(data.person_responding);
    this.observation_date = StringOrNullOrUndefined(data.observation_date);
    this.current_insurance_provider = StringOrNullOrUndefined(data.current_insurance_provider);
    this.additional_insurance = StringOrNullOrUndefined(data.additional_insurance);
    this.home_community_description = StringOrNullOrUndefined(data.home_community_description);
    this.has_own_room = BooleanOrNullOrUndefined(data.has_own_room) ?? false;
    this.shares_room_with = StringOrNullOrUndefined(data.shares_room_with);
    this.primary_language_spoken = StringOrNullOrUndefined(data.primary_language_spoken);
    this.history_trauma = StringOrNullOrUndefined(data.history_trauma);
    this.comorbidities = StringOrNullOrUndefined(data.comorbidities);
    this.household_members = Array.isArray(data.household_members) ? data.household_members : [];
    this.concurrent_97153_97156_medical_necessity = StringOrNullOrUndefined((data as Record<string, unknown>)[
      'concurrent_97153_97156_medical_necessity'
    ] as string | null | undefined);
  
    const rawImpairs = (data as Record<string, unknown>)['impairs_other_services_without_rbt'] as unknown;
    if (typeof rawImpairs === 'string') {
      const v = rawImpairs.trim().toLowerCase();
      this.impairs_other_services_without_rbt = v === 'yes' || v === 'true' || v === '1';
    } else {
      this.impairs_other_services_without_rbt = BooleanOrNullOrUndefined(rawImpairs as boolean | null | undefined) ?? false;
    }
    
    this.impairs_other_services_description = StringOrNullOrUndefined((data as Record<string, unknown>)['impairs_other_services_description'] as string | null | undefined);
    this.documents_and_result = StringOrNullOrUndefined((data as Record<string, unknown>)['documents_and_result'] as string | null | undefined);
    this.created_at = data.created_at ? DateOrNullOrUndefined(data.created_at) : undefined;
    this.updated_at = data.updated_at ? DateOrNullOrUndefined(data.updated_at) : undefined;
    this.medical_development_history = data.medical_development_history ? new MedicalDevelopmentHistory(data.medical_development_history) : undefined;
    this.family_legal_history = data.family_legal_history ? new FamilyLegalHistory(data.family_legal_history) : undefined;
    this.educational_therapeutic_programs = Array.isArray(data.educational_therapeutic_programs) ? data.educational_therapeutic_programs.map(p => new EducationalTherapeuticProgram(p)) : [];
    this.school_daycare_info = data.school_daycare_info ? new SchoolDaycareInfo(data.school_daycare_info) : undefined;
    this.aba_services = data.aba_services ? new AbaServicesInfo(data.aba_services) : undefined;
    this.health_behaviors = data.health_behaviors ? new HealthBehaviors(data.health_behaviors) : undefined;
    this.past_current_treatments = data.past_current_treatments ? new PastCurrentTreatments(data.past_current_treatments) : undefined;
    this.educational_medical_status = data.educational_medical_status ? new EducationalMedicalStatus(data.educational_medical_status) : undefined;
    this.other_therapy_services = Array.isArray(data.other_therapy_services) ? data.other_therapy_services.map(o => new OtherTherapyService(o)) : [];
    this.conducted_assessments = Array.isArray(data.conducted_assessments) ? data.conducted_assessments.map(c => new ConductedAssessmentRecord(c)) : [];
    this.setting_events_antecedents = Array.isArray(data.setting_events_antecedents) ? data.setting_events_antecedents.map(s => new SettingEventAntecedent(s)) : [];
    this.preference_assessment = data.preference_assessment ? new PreferenceAssessment(data.preference_assessment) : undefined;
    this.patient = data.patient ? new InitialAssessmentPatientSummary(data.patient) : undefined;
  }
}
